import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Instagram, Linkedin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="15556" id="footer" ref={ref} className={`bg-[#e0f2f2] text-[#222222] py-16 transition-opacity duration-700 font-sans ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8 mb-16">
          {}
          <div className="flex flex-col items-start">
            <Link to="/HomePage" className="block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597246/img/odins_crow_logo.png" alt="AI looks at AI Logo" className="h-7 w-auto object-contain" />
            </Link>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-[14px] font-bold uppercase tracking-widest mb-2 text-[#ea0f0f]">
              Navigation
            </h3>
            <nav className="flex flex-col gap-3">
              <Link to="/HomePage" className="text-[14px] uppercase tracking-wide text-[#337ab7] hover:text-[#ea0f0f] transition-colors">
                Home
              </Link>
              <Link to="#" className="text-[14px] uppercase tracking-wide text-[#337ab7] hover:text-[#ea0f0f] transition-colors">
                Begin Here
              </Link>
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-[14px] font-bold uppercase tracking-widest mb-2 text-[#ea0f0f]">
              Inquiries
            </h3>
            <div className="flex flex-col gap-3 text-[14px] uppercase tracking-wide">
              <Link to="mailto:info@ailooksatai.uk" className="text-[#337ab7] hover:text-[#ea0f0f] transition-colors underline">
                info@ailooksatai.uk
              </Link>
              <span className="text-[#222222]">United Kingdom</span>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-[14px] font-bold uppercase tracking-widest mb-2 text-[#ea0f0f]">
              Community
            </h3>
            <div className="flex flex-col gap-3">
              <Link to="#" className="flex items-center gap-2 text-[14px] uppercase tracking-wide text-[#337ab7] hover:text-[#ea0f0f] transition-colors group">
                <Linkedin className="h-4 w-4 stroke-[1.5] text-[#ea0f0f]" />
                <span>LinkedIn</span>
              </Link>
              <Link to="#" className="flex items-center gap-2 text-[14px] uppercase tracking-wide text-[#337ab7] hover:text-[#ea0f0f] transition-colors group">
                <Instagram className="h-4 w-4 stroke-[1.5] text-[#ea0f0f]" />
                <span>Instagram</span>
              </Link>
            </div>
          </div>
        </div>

        <Separator className="bg-[#d1e8e8] mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[14px] uppercase tracking-widest text-[#222222]">
          <p className="font-bold">
            <Link to="#" className="text-[#337ab7] underline hover:text-[#ea0f0f] transition-colors">
              CONTACT
            </Link>
          </p>
          <div className="flex gap-6">
            <span className="text-[#222222]">
              © 2025 - 2026 Alan F Harrison and AI
            </span>
          </div>
        </div>
      </div>
    </section>;
}